import {
  API_INTEGRATIONS,
  SHEET_INTEGRATIONS,
} from "@/pages/landingPage/constants/integrations";

export const SITE_URL = "https://fidexa.com.br";
export const PATH = "/integracoes";
// Sem o sufixo "| Fidexa": o titleTemplate de src/App.tsx acrescenta.
export const TITLE = "Integrações com ERP para cobrança de crediário";
export const OG_TITLE = `${TITLE} | Fidexa`;
export const DESCRIPTION =
  "Integrações da Fidexa com o ERP da sua loja, por API ou planilha: a carteira do crediário próprio entra na plataforma e a cobrança roda sozinha no WhatsApp.";

// Fonte: .claude/skills/seo/reference/fidexa-empresa.md (Portal ERP, Novo Varejo, Baguete).
export const HERO_METRICS = [
  { value: "R$ 39,34 mi", label: "recuperados para lojistas" },
  { value: "249", label: "empresas usando a Fidexa" },
];

export const BREADCRUMB = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Início", item: `${SITE_URL}/` },
    {
      "@type": "ListItem",
      position: 2,
      name: "Integrações",
      item: `${SITE_URL}${PATH}`,
    },
  ],
};

export const INTEGRATIONS_LIST = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Integrações da Fidexa com ERPs",
  itemListElement: [...API_INTEGRATIONS, ...SHEET_INTEGRATIONS].map(
    (integration, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: integration.name,
    })
  ),
};
